import React from 'react'
import { LandingPageDto } from 'api/ClientArea/LandingPageDto'
import { PromoMaterialLandingPageDto } from 'api/ClientArea/PromoMaterialDto'
import { PromoMaterialsOptionsDto } from 'api/ClientArea/PromoMaterialsOptionsDto'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientAreaApiClient } from 'utils/api/clientAreaApi'
import { useCallbackWithForceRefresh } from 'utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from 'utils/api/useFetch'
import { FormSubmitValues } from 'utils/formValidation'

import { PermissionDto } from '../../../api/Identity/Types/PermissionDto'
import {
  CreatePromoMaterialValues,
  PromoMaterialForm,
  UpdatePromoMaterialValues,
} from './PromoMaterialForm'

interface OuterProps {
  data: LandingPageDto
  promoMaterial: PromoMaterialLandingPageDto
  promoMaterialsOptions: PromoMaterialsOptionsDto
  permissions: PermissionDto[]
  onSubmit(
    values: FormSubmitValues<UpdatePromoMaterialValues | CreatePromoMaterialValues>
  ): Promise<void>
}

export const PromoMaterialEditForm: React.FC<OuterProps> = (props) => {
  const clientAreaApiClient = useApiClient(ClientAreaApiClient)

  const { callback: fetchData } = useCallbackWithForceRefresh(() => {
    return clientAreaApiClient.getPromoMaterialsByPromoMaterialIdForLandingPage(
      props.promoMaterial.id
    )
  }, [])
  const { data: promoMaterial, isLoading } = useFetchOne(fetchData)

  return (
    <Loading isLoading={isLoading}>
      {promoMaterial && <PromoMaterialForm {...props} promoMaterial={promoMaterial} />}
    </Loading>
  )
}
